import { connect } from '@atlassian/jira-react-redux';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import { getGlobalError } from '../../../state/selectors/summary';
import type { State } from '../../../state/types';
import PageError from './view';

const mapStateToProps = (state: State) => ({
	errorMessage: getGlobalError(state) || '',
});

const mapDispatchToProps = () => ({
	onReload: () => {
		triggerAnalyticsEvent('summary.page-error.reload.clicked');
		window.location.reload();
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(PageError);
